import { useWebhookFieldDeleteIntegrationWebhookFieldDeleteMutation } from '@shared/api';

export const useDeleteIntegrationField = () => {
  const [deleteIntegrationFieldMutation, { isLoading: isDeleteIntegrationFieldLoading }] =
    useWebhookFieldDeleteIntegrationWebhookFieldDeleteMutation();

  const deleteIntegrationField = async (integrationFieldId: number) => {
    try {
      await deleteIntegrationFieldMutation({
        webhookIntegrationFieldId: integrationFieldId,
      }).unwrap();
    } catch {}
  };

  return {
    deleteIntegrationField,
    isDeleteIntegrationFieldLoading,
  };
};
